import { flagColors } from './Constants';
import './Reporting.css';
import Helper from "../../helper/helper";
import Ajax from "../../ajax/ajax";
import { qarFindingsColumns } from './Constants';
import { exportTableToExcel } from '../../helper/fileExtensions';

export const RenderInactiveUsersTable = (rowData) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: 'black',
                backgroundColor: '#F8F8F8',
            }}
        >
            <cite title="Permission Groups">Accounts</cite>
            <div className="detail-panel-table">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr className="table-secondary">
                            <th scope="col">Account</th>
                            <th scope="col">System</th>
                            <th scope="col">User Name</th>
                            <th scope="col">Account Status</th>
                            <th scope="col">Permission Group</th>
                            <th scope="col">Description</th>
                            <th scope="col">Last Login</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.accounts ? rowData.accounts.sort(function (a, b) {
                            if (a.enabled < b.enabled) { return 1; }
                            if (a.enabled > b.enabled) { return -1; }
                            return 0;
                        }).map((r, index) => {
                            const { accountName, systemName, username, enabled, permissionGroups, lastLoginDate } = r

                            return (
                                <>
                                    <tr key={index}>
                                        <td id="detail-panel-td"><h4>{accountName}</h4></td>
                                        <td id="detail-panel-td"><h4>{systemName}</h4></td>
                                        <td id="detail-panel-td"><h4>{username}</h4></td>
                                        <td id="detail-panel-td" style={{ color: 'red' }}><h4>{enabled ? "Active" : "Inactive"}</h4></td>
                                        <td></td><td></td>
                                        {systemName === "AD" ? <td id="detail-panel-td"><h4>{Helper.parseDate(lastLoginDate)}</h4></td> : <td></td>}
                                    </tr>
                                    {permissionGroups ? permissionGroups.map((pg, i) => {
                                        const { permissionGroupName, permissionGroupDescription } = pg
                                        return (
                                            <tr key={i}>
                                                <td></td><td></td><td></td><td></td>
                                                <td id="detail-panel-td">{permissionGroupName}</td>
                                                <td id="detail-panel-td">{permissionGroupDescription}</td>
                                                <td></td>
                                            </tr>
                                        )
                                    }) : null}
                                </>
                            )
                        }) : null}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export const RenderIntersectionTable = (rowData) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: 'black',
                backgroundColor: '#F8F8F8',
            }}
        >
            <cite title="Permission Groups">Permission Groups</cite>
            <div className="detail-panel-table">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr className="table-secondary">
                            <th scope="col">Account</th>
                            <th scope="col">System</th>
                            <th scope="col">User Name</th>
                            <th scope="col">Account Status</th>
                            <th scope="col">Permission Group</th>
                            <th scope="col">Description</th>
                            <th scope="col">Last Login</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.accounts ? rowData.accounts.map((r, index) => {
                            const { systemName, username, accountName, enabled, roles, permissionGroups, lastLoginDate } = r

                            return (
                                <>
                                    <tr key={index}>
                                        <td><h4><strong>{accountName}</strong></h4></td>
                                        <td><h4><strong>{systemName}</strong></h4></td>
                                        <td><h4><strong>{username}</strong></h4></td>
                                        <td><h4><strong>{enabled === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</strong></h4></td>
                                        <td></td><td></td>
                                        {systemName === "AD" ? <td><h4><strong>{Helper.parseDate(lastLoginDate)}</strong></h4></td> : <td></td>}
                                    </tr>
                                    {roles ? roles.map((pg, i) => {
                                        const { name, permissionGroups } = pg
                                        return (
                                            <>
                                                <tr key={index} style={{ "font-size": "13px", 'font-weight': '700' }}>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>Role: <strong>'{name}'</strong></td><td></td>
                                                    <td></td>
                                                </tr>
                                                {permissionGroups ? permissionGroups.map((pg, k) => {
                                                    const { permissionGroupName, permissionGroupDescription, permissionGroupFlag } = pg
                                                    return (
                                                        <tr key={k} style={{ color: flagColors[permissionGroupFlag], "font-size": "13px", 'font-weight': '700' }}>
                                                            <td id="detail-panel-td"></td>
                                                            <td id="detail-panel-td"></td>
                                                            <td id="detail-panel-td"></td>
                                                            <td id="detail-panel-td"></td>
                                                            <td id="detail-panel-td">{permissionGroupFlag == "0" || permissionGroupFlag == "1" ? permissionGroupName : null}</td>
                                                            <td id="detail-panel-td" style={{ "color": "black" }}>{permissionGroupDescription}</td>
                                                            <td></td>
                                                        </tr>
                                                    )
                                                }) : null}
                                            </>
                                        )
                                    }) : null}
                                    {permissionGroups ? permissionGroups.filter(x => x.permissionGroupFlag == "2" || x.permissionGroupFlag == "3").map((pg, i) => {
                                        const { permissionGroupName, permissionGroupDescription, permissionGroupFlag } = pg
                                        return (
                                            <tr key={i} style={{ color: flagColors[permissionGroupFlag], "font-size": "13px", 'font-weight': '700' }}>
                                                <td id="detail-panel-td"></td>
                                                <td id="detail-panel-td"></td>
                                                <td id="detail-panel-td"></td>
                                                <td id="detail-panel-td"></td>
                                                <td id="detail-panel-td">{permissionGroupName}</td>
                                                <td id="detail-panel-td" style={{ "color": "black" }}>{permissionGroupDescription}</td>
                                            </tr>)
                                    }) : null}
                                </>
                            )
                        }) : null}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export const RenderUsersWithoutRolesTable = (rowData) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: 'black',
                backgroundColor: '#F8F8F8',
            }}
        >
            <cite title="Permission Groups">Accounts</cite>
            <div className="detail-panel-table">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr className="table-secondary">
                            <th scope="col">Account</th>
                            <th scope="col">System</th>
                            <th scope="col">User Name</th>
                            <th scope="col">Account Status</th>
                            <th scope="col">Permission Group</th>
                            <th scope="col">Description</th>
                            <th scope="col">Last Login</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.accounts ? rowData.accounts.sort(function (a, b) {
                            if (a.enabled < b.enabled) { return 1; }
                            if (a.enabled > b.enabled) { return -1; }
                            return 0;
                        }).map((r, index) => {
                            const { accountName, systemName, username, enabled, permissionGroups, lastLoginDate } = r

                            return (
                                <>
                                    <tr key={index}>
                                        <td id="detail-panel-td"><h4>{accountName}</h4></td>
                                        <td id="detail-panel-td"><h4>{systemName}</h4></td>
                                        <td id="detail-panel-td"><h4>{username}</h4></td>
                                        <td id="detail-panel-td" style={{ color: 'red' }}><h4>{enabled ? <span style={{ color: 'green' }}>Active</span> : <span style={{ color: 'red' }}>Inactive</span>}</h4></td>
                                        <td></td><td></td>
                                        {systemName === "AD" ? <td id="detail-panel-td"><h4>{Helper.parseDate(lastLoginDate)}</h4></td> : <td></td>}
                                    </tr>
                                    {permissionGroups ? permissionGroups.map((pg, i) => {
                                        const { permissionGroupName, permissionGroupDescription } = pg
                                        return (
                                            <tr key={i}>
                                                <td></td><td></td><td></td><td></td>
                                                <td id="detail-panel-td">{permissionGroupName}</td>
                                                <td id="detail-panel-td">{permissionGroupDescription}</td>
                                                <td></td>
                                            </tr>
                                        )
                                    }) : null}
                                </>
                            )
                        }) : null}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export const RenderPermissionGroups = (rowData) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: 'black',
                backgroundColor: '#F8F8F8',
            }}
        >
            <cite title="Permission Groups">Permission Groups</cite>
            <div className="detail-panel-table">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr className="table-secondary">
                            <th scope="col">Permission Group</th>
                            <th scope="col">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.memberOf.map((r, index) => {
                            const { name, description } = r

                            return (
                                <>
                                    <tr key={index}>
                                        <td id="detail-panel-td"><h4>{name}</h4></td>
                                        <td id="detail-panel-td"><h4>{description}</h4></td>
                                    </tr>
                                </>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export const RenderGCPDetails = (rowData) => {
    return (
        <div
            style={{
                textAlign: 'center',
                color: 'black',
                backgroundColor: '#F8F8F8',
            }}
        >
            <div className='detail-panel-table gcp-detail-panel'>
                <table className='table table-bordered table-hover'>
                    <thead>
                        <tr className='table-secondary'>
                            <th scope='col' rowSpan='2'>Projects</th>
                            <th scope='col' colSpan='2'>Roles</th>
                        </tr>
                        <tr className='table-secondary'>
                            <th scope='col' className='sub-header'>Role Name</th>
                            <th scope='col' className='sub-header'>Granted From</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.projects.map(pr =>
                            pr.roles.map((r, index) => {
                                return (
                                    <>
                                        <tr key={index}>
                                            {index === 0 ? <td id='0detail-panel-td' rowSpan={pr.roles ? pr.roles.length : 1}><h4>{pr.name}</h4></td> : null}
                                            <td id='detail-panel-td'><h4>{r.name}</h4></td>
                                            <td id='detail-panel-td'><h4>{r.grantedFrom}</h4></td>
                                        </tr>
                                    </>
                                )
                            }))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const exportQarFindingsSuccess = (response) => {
    exportTableToExcel(qarFindingsColumns, response.data, 'QAR-Findings');
};

const exportQarFindingsError = (error) => {
    console.log(error);
}

export const exportQarFindingsClickHandler = (complianceReviewId) => {
    Ajax.getAllFindingsForAllAccounts(complianceReviewId, exportQarFindingsSuccess, exportQarFindingsError);
}